module.exports = __webpack_public_path__ + "static/media/the-dutch-cover.642076e6.png";